import type { InitialState } from './types';

const getInitialState = (preferDirects: boolean): InitialState => ({
  preferDirects,
  version: '0.0.0',
});

export default getInitialState;
